import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import withSounds from 'containers/withSounds';
import LoadingIndicator from 'components/LoadingIndicator';
import { NUGGET, RUBY, SAPPHIRE, WCHIP } from 'utils/constants';
import PurpleWIcon from 'resources/PurpleW.png';
import {
  getCategoryItemClassName,
  getCategoryLogo,
  getModalBodyBackgroundClass,
  getWScoreValueForGemsToTrade
} from '../../WStoreUtils';
import WStoreConfirmation from '../WStoreConfirmation';
import WStoreTrades from '../WStoreTrades';
import BankerMascot from '../assets/BankerMascot.png';
import ExitButtonIcon from '../assets/Button-CloseModal-Red.png';
import './WStorePurchaseWithTradeModal.css';

const BtnWithSounds = withSounds({ mouseEnterSound: true })(Button);

const GEM_TYPE_LABEL = {
  [NUGGET]: 'nuggets',
  [RUBY]: 'rubies',
  [SAPPHIRE]: 'sapphires',
  [WCHIP]: 'wchips'
};

function WStorePurchaseWithTradeModal({
  selectedItem,
  patronAssets,
  onPurchase,
  purchaseRequested,
  purchaseConfirmation,
  hidden,
  onClose,
  exchangeRates
}) {
  const show = selectedItem && !hidden;
  const { nuggetCost, rubyCost, sapphireCost, wchipCost } = selectedItem;
  const { nuggets, rubies, sapphires, wchips } = patronAssets;
  const { wscorePerNugget, wscorePerRuby, wscorePerSapphire, wscorePerWChip } =
    exchangeRates;

  const costs = [nuggetCost, rubyCost, sapphireCost, wchipCost];
  const assets = [nuggets, rubies, sapphires, wchips];
  const exchange = [
    wscorePerNugget,
    wscorePerRuby,
    wscorePerSapphire,
    wscorePerWChip
  ];
  const tradeItems = [NUGGET, RUBY, SAPPHIRE, WCHIP]
    .map((gemType, i) => ({
      gemType: gemType,
      wscoreAmount: getWScoreValueForGemsToTrade(
        costs[i],
        assets[i],
        exchange[i]
      ),
      gemAmount: costs[i] - assets[i]
    }))
    .filter(item => item.gemAmount > 0);

  const renderItemImage = selectedItem => {
    return (
      <div className="item-image-column">
        <img
          className="item-image"
          src={selectedItem.imageUrl || PurpleWIcon}
          alt={selectedItem.name}
        />
        <img
          className="category-image"
          src={getCategoryLogo(selectedItem.classCode)}
          alt={selectedItem.classCode}
        />
      </div>
    );
  };

  const handlePurchase = e => {
    let currencyItemsPurchased = {
      nuggets: 0,
      rubies: 0,
      sapphires: 0,
      wchips: 0
    };

    tradeItems.forEach(
      tradeItem =>
        (currencyItemsPurchased[GEM_TYPE_LABEL[tradeItem.gemType]] =
          tradeItem.gemAmount)
    );
    onPurchase(e, currencyItemsPurchased);
  };

  return (
    show && (
      <Modal
        className={`wstore-purchase-with-trade-modal ${
          purchaseConfirmation ? 'modal-overlay' : ''
        }`}
        show={true}
        onHide={onClose}
      >
        <Modal.Body
          bsPrefix={`${getModalBodyBackgroundClass(
            selectedItem
          )} ${getCategoryItemClassName(selectedItem.classCode)}`}
        >
          <div className="title-container">
            <button
              className="exit-modal-button"
              type="button"
              onClick={onClose}
            >
              <img src={ExitButtonIcon} alt="Close trade modal" />
            </button>
            <div className="title">{selectedItem.name}</div>
          </div>
          <React.Fragment>
            <div className="modal-container">
              <div className="body-column">
                {renderItemImage(selectedItem)}
                <div className="trade-details">
                  <div className="banker-container">
                    <div className="banker-offer-text">
                      <img className="banker-img" src={BankerMascot} alt="" />
                      Looks like you could use some extra gems. I have the
                      perfect offer for you!
                    </div>
                  </div>
                  <div className="trade-total">
                    <div className="item-info wstore-gems-container">
                      <WStoreTrades tradeItems={tradeItems} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {purchaseRequested && <LoadingIndicator overlay />}
          </React.Fragment>

          <div className="footer-buttons">
            <BtnWithSounds
              className="btn-redeem"
              variant="orange"
              onClick={handlePurchase}
            >
              Trade
            </BtnWithSounds>
          </div>
        </Modal.Body>

        {purchaseConfirmation && (
          <WStoreConfirmation
            message="Your Trade Was Successful"
            onClose={onClose}
          />
        )}
      </Modal>
    )
  );
}

WStorePurchaseWithTradeModal.propTypes = {
  selectedItem: PropTypes.object,
  patronAssets: PropTypes.any,
  onPurchase: PropTypes.func,
  purchaseRequested: PropTypes.bool,
  purchaseConfirmation: PropTypes.bool,
  purchaseResponseMsg: PropTypes.string,
  purchaseEmailMsg: PropTypes.string,
  hidden: PropTypes.bool,
  onClose: PropTypes.func,
  exchangeRates: PropTypes.shape({
    wscorePerNugget: PropTypes.number,
    wscorePerRuby: PropTypes.number,
    wscorePerSapphire: PropTypes.number,
    wscorePerWChip: PropTypes.number
  })
};

export default WStorePurchaseWithTradeModal;
